import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * Utility function for merging Tailwind CSS classes and handling conflicts
 *
 * Uses clsx to conditionally join class names together and tailwind-merge
 * to properly handle Tailwind CSS class conflicts by merging them intelligently.
 *
 * @example
 * // Basic usage
 * cn('px-2 py-1', 'bg-blue-500') // => 'px-2 py-1 bg-blue-500'
 *
 * // Conditional classes
 * cn('p-2', { 'bg-red-500': isError })
 *
 * // Handling conflicts (last class wins)
 * cn('px-2 py-1', 'p-4') // => 'p-4'
 *
 * @param inputs - Class names, objects, or arrays of class names
 * @returns Merged and deduped class name string
 */
export const cn = (...inputs: ClassValue[]) => twMerge(clsx(inputs))

export default cn
